import { useSelector } from 'react-redux';
import { isEmpty } from 'ramda';

import { ListingLayout } from '../../components/ListingLayout';
import { AgencyCard } from '../../components/AgencyCard';
import { ParticipationList } from '../../components/ParticipationList';
import { getAgenciesItems } from '../../selectors/listing';
import { CardAvatarContainer } from '../CardAvatarContainer';
import { EmptyListingStubContainer } from '../EmptyListingStubContainer';
import { useOpenCard } from '../../utils/openCard';
import { getSuperAgentBadge } from '../SuperAgentLevelViewContainer';

export function AgenciesListingContainer() {
  const agenciesItems = useSelector(getAgenciesItems);
  const onClick = useOpenCard();

  if (isEmpty(agenciesItems)) {
    return <EmptyListingStubContainer />;
  }

  return (
    <ListingLayout>
      {agenciesItems.map(
        ({
          cianUserId,
          age,
          name,
          offersCount,
          services,
          userTrustLevelNumber,
          userTrustLevelName,
          participations,
        }) => {
          return (
            <AgencyCard
              key={cianUserId}
              onClick={() => onClick(cianUserId)}
              agentId={cianUserId}
              previewImg={<CardAvatarContainer agentId={cianUserId} />}
              age={age}
              name={name}
              participations={<ParticipationList participations={participations} />}
              offersCount={offersCount}
              services={services}
              superAgentBadge={getSuperAgentBadge(userTrustLevelNumber, userTrustLevelName)}
            />
          );
        },
      )}
    </ListingLayout>
  );
}
